var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 64,
    viewBox: "0 0 1 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -2.18557e-8,
    x2: 0.500003,
    y2: 64,
    stroke: "#CBCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLine);
export default __webpack_public_path__ + "static/media/profileLine.e141d9c9be945fcb3a431da1f2b1dba9.svg";
export { ForwardRef as ReactComponent };